import type { LucideIcon } from "lucide-react";

import type { SalesTypeValue } from "@/components/backoffice/cat/vehicle-assignment/sales-channels-step";
import type { VehicleAssignmentStep } from "@/components/backoffice/cat/vehicle-assignment/vehicle-assignment-step-progress";
import type { Kvps } from "@/lib/kvps";

export type VehicleAssignmentFlowContext = {
  kvps: Kvps | null | undefined;
  /** AVS: selected sales channel (VDL, VDS, Flotte). */
  avsSalesChannel?: SalesTypeValue | "";
  /** AVS: selected internal account id (stringified). */
  avsInternalAccountId?: string;
};

export type VehicleAssignmentStepDefinition = {
  description: string;
  icon: LucideIcon;
  id: string;
  title: string;
  when?: (ctx: VehicleAssignmentFlowContext) => boolean;
};

export function filterVisibleVehicleAssignmentDefinitions(
  definitions: readonly VehicleAssignmentStepDefinition[],
  ctx: VehicleAssignmentFlowContext,
): VehicleAssignmentStepDefinition[] {
  return definitions.filter((d) => !d.when || d.when(ctx));
}

export function toVehicleAssignmentProgressSteps(
  visible: readonly VehicleAssignmentStepDefinition[],
): VehicleAssignmentStep[] {
  return visible.map((d, index) => ({
    description: d.description,
    icon: d.icon,
    step: index + 1,
    title: d.title,
  }));
}
